<template>
  <d-form-row class="m-0">
    <h6 class="mx-1 my-3">Proteção pessoal ocupacional</h6>
    <ul class="mx-1 epi-list">
      <li v-for="(model, index) in list" :key="model.id">
        <d-form-row>
          <d-col cols="3">
            <label>Tipo de E.P.I</label>
            <input
              type="text"
              class="form-control"
              placeholder="Tipo de E.P.I"
              v-model="model.type"
              required
            />
          </d-col>
          <d-col cols="3">
            <label>Fabricante</label>
            <input
              type="text"
              class="form-control"
              placeholder="Fabricante"
              v-model="model.manufacturer"
              required
            />
          </d-col>
          <d-col cols="3">
            <label>Modelo</label>
            <input
              type="text"
              class="form-control"
              placeholder="Modelo"
              v-model="model.model"
              required
            />
          </d-col>
          <d-col cols>
            <label>Atenuação</label>
            <input
              type="number"
              min="0"
              class="form-control"
              placeholder="Atenuação"
              v-model="model.number"
              @input="calculateTotal"
              required
            />
          </d-col>
          <d-col cols="auto" class="d-flex align-items-end mb-2 justify-content-end">
            <i class="cursor-pointer fas fa-plus text-success" @click="addRow()" v-if="index + 1 === list.length"></i>
            <i class="cursor-pointer fas ml-2 fa-minus text-danger" @click="removeRow(index)" ></i>
          </d-col>
        </d-form-row>
      </li>
    </ul>
  </d-form-row>
</template>

<script>
import Events from '_utils/events';
import { _UPDATE_SAMPLE_ATTENUATION_NOISE_, EPI_ROW } from '../SampleModel';

export default {
  name: 'EPI-list',
  props: {
    list: {
      type: Array,
      default: () => [{ ...EPI_ROW }],
    },
  },
  methods: {
    calculateTotal() {
      const total = this.list.reduce((acc, item) => acc + (Number(item.number) || 0), 0);
      Events.$emit(_UPDATE_SAMPLE_ATTENUATION_NOISE_, total);
    },
    addRow() {
      this.list.push({ ...EPI_ROW });
    },
    removeRow(index) {
      this.list.splice(index, 1);
      if (this.list.length === 0) {
        this.addRow();
      }
    },
  },
  watch: {
    list: {
      handler(value) {
        this.$emit('update:list', value);
      },
      deep: true,
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.epi-list {
  padding: 0;
  list-style: none;
  width: 100%;
  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
